export const FETCH_ACTIVITYLOG_REQUEST = 'FETCH_ACTIVITYLOG_REQUEST';
export const FETCH_ACTIVITYLOG_SUCCESS = 'FETCH_ACTIVITYLOG_SUCCESS';
export const FETCH_ACTIVITYLOG_FAILURE = 'FETCH_ACTIVITYLOG_FAILURE';
